import { render } from "./pageTopic.vue?vue&type=template&id=1b59a297&scoped=true"
import script from "./pageTopic.vue?vue&type=script&lang=js"
export * from "./pageTopic.vue?vue&type=script&lang=js"

import "./pageTopic.vue?vue&type=style&index=0&id=1b59a297&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b59a297"]])

export default __exports__